export default __webpack_public_path__ + "static/media/last-step-cg-create-plwd.eca1208b.png";